import React from 'react'
import { useParams, Link } from '@tanstack/react-router'
import { useAuth } from '@/hooks/useAuth'
import { withPageProtection } from '@/lib/rbac/hoc'
import { PAGES } from '@/lib/rbac/constants'
import { Button } from '@/components/ui/Button'
import { LoadingSpinner } from '@/components/ui/LoadingSpinner'
import { DepartmentForm } from '@/components/workforce/DepartmentForm'
import { useDepartment } from '@/hooks/useWorkforce'
import { ArrowLeft, Building2 } from 'lucide-react'

function EditDepartmentContent() {
  const params = useParams({ from: '/_auth/workforce/departments/$departmentId/edit' })
  const departmentId = params.departmentId

  const { department, loading, error } = useDepartment(departmentId)

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (error || !department) {
    return (
      <div className="text-center py-12">
        <p className="text-red-500 mb-4">{error || 'Departamento não encontrado'}</p>
        <Link to="/workforce/departments">
          <Button variant="outline">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar para Departamentos
          </Button>
        </Link>
      </div>
    )
  }

  // Convert DepartmentWithDetails to Department for the form
  const departmentForForm = {
    ...department,
    budget: typeof department.budget === 'number' ? department.budget : department.budget?.allocated
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Link to={`/workforce/departments/${departmentId}` as any}>
          <Button variant="ghost" size="sm">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar
          </Button>
        </Link>
        <div>
          <h1 className="font-display text-3xl sm:text-4xl font-bold text-white flex items-center gap-3">
            <Building2 className="w-8 h-8 text-brand-primary" />
            Editar {department.name}
          </h1>
          <p className="font-body text-brand-gray mt-2">
            Atualize as informações do departamento
          </p>
        </div>
      </div>

      {/* Form */}
      <DepartmentForm mode="edit" department={departmentForForm} />
    </div>
  )
}

// Apply RBAC protection
export default withPageProtection(EditDepartmentContent, PAGES.WORKFORCE_DEPARTMENTS)
